import { Box, styled, Table, TableHead } from '@mui/material';

export const StyleSkeletonTable = styled(Table)(() => ({
  border: '1px solid #C0C7CA',
  borderRadius: '8px',
  '&.MuiTable-root': {
    borderCollapse: 'separate !important',
  },
}));

export const StyleHeading = styled(TableHead)(() => ({
  display: 'inline-block',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F3F4F8',
  width: '100%',
  '&.MuiTableHead-root': {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
}));

export const StyleBoxToolbar = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  borderBottom: '1px solid #C0C7CA',
  padding: '5px 20px',
}));

export const StyleBox = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  padding: '5px 20px',
  borderBottom: '1px solid #C0C7CA',
}));

export const StyleBody = styled(TableHead)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 20px',
}));
